import gql from 'graphql-tag';

const CREATE_MILESTONE = gql`
  mutation createMilestone($data: MilestoneCreateInput!) {
    createMilestone(data: $data) {
      id
      name
      description
      startDate
      dueDate
      status
      createdAt
      updatedAt
      project {
        id
        name
      }
      tasks {
        id
        name
        status
      }
    }
  }
`;

export default CREATE_MILESTONE;
